import { lazy } from 'react';

import paths from './route-paths';

const PaymentLinkRoutes = [
  {
    path: paths.paymentLink,
    component: lazy(() => import('payment-link/pages/details')),
  },
  {
    path: paths.linkDetails,
    component: lazy(() => import('payment-link/pages/details')),
  },
  {
    path: paths.authentication,
    component: lazy(() => import('payment-link/pages/authentication')),
  },
  {
    path: paths.selectMethod,
    component: lazy(() => import('payment-link/pages/payment-method/select-payment-method')),
  },
  {
    path: paths.paymentSummary,
    component: lazy(() => import('payment-link/pages/payment-method/pm-summary')),
  },
  {
    path: paths.selectCard,
    component: lazy(() => import('payment-link/pages/credit-card/list-card/list-card-page')),
  },
  {
    path: paths.addCard,
    component: lazy(() => import('payment-link/pages/credit-card/add-card/add-card-page')),
  },
  {
    path: paths.walletSummary,
    component: lazy(() => import('payment-link/pages/wallet')),
  },
  {
    path: paths.manual,
    component: lazy(() => import('payment-link/pages/card/card-deposit-page')),
  },
  {
    path: paths.identityValidation,
    component: lazy(() => import('deposit/pages/identity-validation-page')),
  },
  {
    path: paths.profile,
    component: lazy(() => import('payment-link/pages/profile/profile-page')),
  },
  {
    path: paths.pay,
    component: lazy(() => import('payment-link/pages/pay/payment-page')),
  },
  {
    path: paths.waiting,
    component: lazy(() => import('payment-link/pages/waiting/waiting-payment-page')),
  },
  {
    path: paths.completed,
    component: lazy(() => import('payment-link/pages/completed')),
  },
  {
    path: paths.error,
    component: lazy(() => import('payment-link/pages/error')),
  },
];

export default PaymentLinkRoutes;
